/* eslint-disable */
export default {
  activeCall: 'Chamada ativa',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
